module.exports = __webpack_public_path__ + "media/images/chat-gpt-plus-voip-95d5ee631c6b65e7e3248018ba4d8d54.png";